//*** Import React Library
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import Axios from 'axios'
import AxiosInstance from '../Axios/AxiosInstance';
import "../../Assets/Styles/robot.css";
import { hasJWTToken } from "../Account/RouteGuard";
import "../../Assets/Styles/Form.css";
import * as FaIcons from "react-icons/fa";
import Modal from 'react-bootstrap/Modal';
//*** Create custom style for react table
const customStyles = {
    table: {
        style: {
            border: "none",
            fontSize: "100%"
        },
    },
    header: {
        backgroundColor: "transparent",
    },
    rows: {
        style: {
            backgroundColor: "transparent",
        },
    },
    headRobot: {
        style: {
            backgroundColor: "transparent",
            fontSize: "110%"
        },
    },
    pagination: {
        style: {
            backgroundColor: "transparent",
            fontWeight: "600",
        },
    },
    headCells: {
        style: {
            borderBottom: "none",
            fontWeight: "700",
            fontSize: "110%"
        },
    },
};
export const SearchBlockRobots = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [blockRobotData, setBlockRobotData] = useState([]);
    const [blockRobotList, setBlockRobotList] = useState([]);
    const [blockRobotID, setBlockRobotID] = useState("");
    const [blockName, setBlockName] = useState("");
    //*** Create columns for react table
    const columns = [
        { name: "ID", selector: (row) => <a className="alink" onClick={() => editBlokRobots(row.block_robot_id)}>{row.block_robot_id}</a>, sortable: true, },
        { name: "Plant Name", selector: (row) => row.plant_name, sortable: true, },
        { name: "Block Name", selector: (row) => row.block_name, sortable: true },
        { name: "Robot Name", selector: (row) => row.robot_name, sortable: true },
        { name: "Date", selector: (row) => row.block_robot_added_date, sortable: true },
        { name: "Delete", selector: (row) => <a className="alink" onClick={() => showModal(row.block_robot_id, row.robot_name)}>Delete</a>, sortable: true, },
    ];
    //** Show Modal
    const showModal = (block_robot_id, block_name) => {
        setBlockRobotID(block_robot_id);
        setBlockName(block_name);
        var divmodal = document.getElementById("dvmodal");
        var divMessage = document.getElementById("dvMessage");
        divmodal.style.display = "block";
        divMessage.innerText = "are you sure to delete Block Robots ID '" + block_robot_id + "'?"
        divmodal.scrollIntoView();
    };
    //** Hide Modal
    const hideModal = (dvmodal) => {
        var dvimodal = document.getElementById(dvmodal);
        dvimodal.style.display = "none";
    };
    //** editBlockRobot
    const editBlokRobots = (blockRobotID) => {
        sessionStorage.removeItem("editBlockRobotID");
        sessionStorage.setItem("editBlockRobotID", blockRobotID);
        window.location.href = "#/EditBlockRobot?pid=" + blockRobotID + "";
    };
    //** Delete Records
    const deleteRecord = async () => {
        var user_id = sessionStorage.getItem("user_id");
        let response = await AxiosInstance.get("/BlockRobots/DeleteBlockRobots?brid=" + blockRobotID + "&uid=" + user_id + "&pn=DeleteBlockRobot");
        hideModal("dvmodal");
        fetchBlockRobotData();
    }
    //*** Seach Textbox text change event
    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
        let tempList = blockRobotData;
        const filteredData = tempList.filter((event) =>
            Object.values(event).some(
                (value) => typeof value === "string" && value.includes(searchTerm)
            )
        );
        if (event.target.value != null) {
            setBlockRobotList(filteredData);
        }
        if (event.target.value === "") {
            setBlockRobotList(blockRobotData);
        }
    };
    //*** Filter table
    const filteredData = blockRobotList.filter((event) =>
        Object.values(event).some(
            (value) => typeof value === "string" && value.includes(searchTerm)
        )
    );
    //*** Use React hooks - if occur any changes on page then useffect() function will run auto
    useEffect(() => {
        //alert("vb");
        fetchBlockRobotData();
    }, [])
    useEffect(() => {
        console.log(blockRobotData)
    }, [blockRobotData])
    //*** Fetch data from API // To Search 94fbr
    const fetchBlockRobotData = async () => {
        var block_robot_id = "1" //sessionStorage.getItem("editBlockId");
        var user_id = sessionStorage.getItem("user_id");
        //alert(user_id);
        var _token = sessionStorage.getItem("token");
        //alert(_token);
        if (_token) _token = "Token exists";
        let response = await AxiosInstance.get("/PlantBlockRobots?bcid=" + block_robot_id + "&uid=" + user_id + "&pn=SearchBlockRobot&sn=SearchAllBlockRobot");
        setBlockRobotData(response.data)
        setBlockRobotList(response.data)
    }
    return (
        <div className="page-container">
            <div className="search-container">
                <h2 className="form-title"><FaIcons.FaSearch /> Search Block Robot</h2>
                <div class="row">
                    <div class="col-1"></div>
                    <div class="col-12"><a className="btndelete" href="#/PlantBlockRobot">Add New Block Robot</a></div>
                </div>
                <div>
                    <div
                        style={{
                            border: "1px solid #c0c0c0",
                            borderRadius: "5px",
                            margin: "2%",
                            backgroundColor: "#fff",
                        }}
                    >
                        <div className="container dvscroll" >
                            <div className="row dvscroll">
                                <div className="col-sm-12">
                                    <input
                                        type="text"
                                        placeholder="Search Results"
                                        style={{
                                            width: "20%",
                                            height: "30px",
                                            margin: "10px",
                                            float: "right",
                                            border: "none",
                                            padding: "1.5%",
                                            borderRadius: "5px",
                                        }}
                                        value={searchTerm}
                                        onChange={handleSearch}
                                    />
                                    <p></p>
                                    <DataTable className="table .table-sm table-hover" sort={true} pagination={true}
                                        search={true}
                                        columns={columns}
                                        data={filteredData}
                                        highlightOnHover={true}
                                        customStyles={customStyles}
                                    >
                                    </DataTable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="dvmodal" class="modalcontainer">
                    <Modal.Dialog size="lg"
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                    >
                        <Modal.Header closeButton onClick={() => hideModal("dvmodal")}>
                            <Modal.Title>
                                Delete Block Robots
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <p>
                                <div id="dvMessage"></div>
                            </p>
                        </Modal.Body>
                        <Modal.Footer>
                            <a variant="secondary" className="btndelete" onClick={() => deleteRecord()}>
                                Delete
                            </a>
                            <a variant="secondary" className="btncancel" onClick={() => hideModal("dvmodal")}>
                                Cancel
                            </a>
                        </Modal.Footer>
                    </Modal.Dialog>
                </div>
            </div>
        </div>
    );
}
export default SearchBlockRobots;